
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { Audio3D } from './Audio3D.jsx'
import { Video } from './Video.jsx'

function VideoElement({ element, index })
{
  const size = Math.max(...element.object.scale.toArray())

  return (
    <Video
      key={`video-${index}-${element.mediaSrc}`}
      size={size}
      src={element.mediaSrc}
      position={element.worldPosition}
      quaternion={element.worldRotation}
      sourceObject={element.object}
      muted={false}
      volume={element.volume}
      framed
    />
  )
}

function AudioElement({ element, index })
{
  const size = Math.max(...element.object.scale.toArray())

  return (
    <Audio3D
      key={`audio-${index}-${element.mediaSrc}`}
      size={size}
      url={element.mediaSrc}
      sourceObject={element.object}
      position={element.worldPosition}
      quaternion={element.worldRotation}
      muted={false}
      volume={element.volume}
      framed
    />
  )
}

/**
 * Media component - renders video and audio elements.
 * Media loads after user interaction due to browser autoplay policies.
 */
export function Media({ sceneManager, interactionManager })
{
  const [ isMediaLoaded, setIsMediaLoaded ] = useState(false)

  const mediaObjects = useMemo(() =>
  {
    return sceneManager?.mediaObjects ?? null
  }, [ sceneManager ])

  const loadMedia = useCallback(() =>
  {
    setIsMediaLoaded(true)
  }, [])

  useEffect(() =>
  {
    if (!mediaObjects) return
    document.addEventListener('click', loadMedia, { once: true })
    return () => document.removeEventListener('click', loadMedia)
  }, [ mediaObjects, loadMedia ])

  if (!isMediaLoaded || !mediaObjects) return null

  const { video = [], audio = [], positionalAudio = [] } = mediaObjects
  const allAudio = [ ...audio, ...positionalAudio ]

  return (
    <group name="media-container">
      {video.map((element, index) => (
        <VideoElement key={`video-${index}`} element={element} index={index} />
      ))}
      {allAudio.map((element, index) => (
        <AudioElement key={`audio-${index}`} element={element} index={index} />
      ))}
    </group>
  )
}

export default Media
